import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Typography, Tooltip, Switch, FormControlLabel } from '@mui/material';

import localization from '../../../localization';
import { setIncludesDefault } from '../../../redux/actions/Account';
import { isIncludesDefaultCustomerSelector } from '../../../redux/selectors/Account';

import '../SideBar.scss';

const IncludesDefault = () => {
  const dispatch = useDispatch();
  const includesDefaultOptions = useSelector(isIncludesDefaultCustomerSelector);

  return (
    <Tooltip title={localization.t('tooltips.resourcesBelongingToNexway')} placement="bottom-start">
      <Box
        width="100%"
        pt="10px"
        display="flex"
        alignItems="center"
        className="includesDefaultWrapper"
      >
        <FormControlLabel
          width={1}
          pl={2}
          control={(
            <Switch
              size="small"
              checked={includesDefaultOptions}
              className={includesDefaultOptions ? '' : 'switch-disabled'}
              onChange={() => dispatch(setIncludesDefault(!includesDefaultOptions))}
            />
          )}
          label={(
            <Box className="searchSection-handling" width={1} pl={2}>
              <Typography
                sx={{
                  color: ({ palette }) => includesDefaultOptions ? '#2196f3' : palette.text.primaryForDarkTheme,
                  fontStyle: 'italic',
                  fontSize: '0.8rem',
                }}
              >
                {localization.t('sideBar.labels.nexway')}
              </Typography>
            </Box>
          )}
        />
      </Box>
    </Tooltip>
  );
};

export default IncludesDefault;
